import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ICreateTimeAssignmentFormData, ICreateTimeAssignmentResponse,  } from "./types";

export const createTimeAssignment = async (formData: ICreateTimeAssignmentFormData[]): Promise<ICreateTimeAssignmentResponse> => {
  try {
    const response = await apiClientSource.post("/task-service/api/tasks-schedule/create", formData);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al crear la asignación de tiempo");
    throw error;
  }
};
